export function tab() {
    // // URLのハッシュから指定されたタブをアクティブにする
    // function getHashID(hashIDName) {
    //     if (hashIDName) {
    //         // タブの設定
    //         document.querySelectorAll('.access__tab a').forEach(function (element) {
    //             var idName = element.getAttribute('href');
    //             if (idName === hashIDName) {
    //                 var parentElm = element.parentNode;
    //                 document.querySelectorAll('.access__tab').forEach(el => el.classList.remove('active'));
    //                 parentElm.classList.add('active');

    //                 // 表示させるエリアの設定
    //                 document.querySelectorAll('.access__area').forEach(el => el.classList.remove('is-active'));
    //                 document.querySelector(hashIDName).classList.add('is-active');
    //             }
    //         });
    //     }
    // }

    // // タブがクリックされたら
    // document.querySelectorAll('.access__tab a').forEach(function (element) {
    //     element.addEventListener('click', function (e) {
    //         e.preventDefault(); // デフォルトの挙動を防ぐ
    //         var idName = element.getAttribute('href');
    //         getHashID(idName); // 設定したタブの読み込み
    //     });
    // });

    // // ページが読み込まれたらすぐに動かす
    // window.addEventListener('load', function () {
    //     // 最初のタブをアクティブにする
    //     var firstTab = document.querySelector('.access__tab:first-child');
    //     if (firstTab) {
    //         firstTab.classList.add('active');
    //     }
    //     // 最初のエリアをアクティブにする
    //     var firstArea = document.querySelector('.access__area:first-child');
    //     if (firstArea) {
    //         firstArea.classList.add('is-active');
    //     }
    //     // URLのハッシュを取得してタブを設定
    //     var hashName = window.location.hash;
    //     getHashID(hashName);
    // });


    document.addEventListener('DOMContentLoaded', function () {
        const tabs = document.querySelectorAll('.access__tab a');
        const areas = document.querySelectorAll('.access__area');
    
        function activateTab(tab) {
            tabs.forEach(t => t.parentNode.classList.remove('active'));
            areas.forEach(area => area.classList.remove('is-active'));
    
            tab.parentNode.classList.add('active');
            const activeArea = document.querySelector(tab.getAttribute('href'));
            if (activeArea) {
                activeArea.classList.add('is-active');
            }
        }
    
        function switchTab(e) {
            e.preventDefault();
            activateTab(this);
        }
    
        tabs.forEach(tab => {
            tab.addEventListener('click', switchTab);
        });
    
        // 最初のタブをアクティブにする（URLにハッシュがない場合）
        if (!window.location.hash && tabs.length > 0) {
            activateTab(tabs[0]);
        } else {
            // URLのハッシュに対応するタブをアクティブにする
            const activeTab = Array.from(tabs).find(tab => tab.getAttribute('href') === window.location.hash);
            if (activeTab) {
                activateTab(activeTab);
            }
        }
    });
    
}
